export enum ChartDataKeys {
  Expenses = 'expenses',
  Result = 'result',
  Revenue = 'revenue',
}
